import FulfillmentKpis from "../../components/fulfillment-kpis/fulfillment-kpis";

const FulfillmentKpisPage = () => <FulfillmentKpis />;

export default FulfillmentKpisPage;
